import {
  CHANGE_BOTACTIVATION,
  CHANGE_PROPERTYID,
  CHANGE_PROPERTYNAME,
  CHANGE_DOMAIN,
  CHANGE_AVATARCLICK,
  CURRENT_GROUPID,
  CURRENT_GROUPNAME,
  CHANGE_LEVEL,
  IS_GROUP_BUTTON,
  CHANGE_INTEGRATION_CHANNEL,
  CHAT_STARTED,
  CHANGE_BACK_TO_LIST,
  CHANGE_CURRENCY,
  CHANGE_MODE
} from "../actions";
const INIT_STATE = {
  botActivation: localStorage.getItem("messengerBotActivation") || "false",
  propertyId: localStorage.getItem("messengerPropertyId") || "-1",
  propertyName: localStorage.getItem("messengerPropertyName") || "",
  domain: localStorage.getItem("messengerDomain") || "",
  avatarClick: sessionStorage.getItem("messengerAvatarClick") || "false",
  groupId: localStorage.getItem("messengerGroupId") || "-1",
  groupName: localStorage.getItem("messengerGroupName") || "",
  level: localStorage.getItem("messengerLevel") || "Property",
  isGroupButton: localStorage.getItem("messengerIsGroupButton") || "false",
  integration_channel: "",
  chat_started: localStorage.getItem("messengerChatStarted") || "false",
  backToList: false,
  currency: localStorage.getItem("messengerCurrency") || null,
  isMessengerMode: true
};

export default (state = INIT_STATE, action) => {

  switch (action.type) {
    case CHANGE_BOTACTIVATION:
      return { ...state, botActivation: action.payload };

    case CHANGE_PROPERTYID:
      return { ...state, propertyId: action.payload };

    case CHANGE_PROPERTYNAME:
      return { ...state, propertyName: action.payload };

    case CHANGE_DOMAIN:
      return { ...state, domain: action.payload };

    case CHANGE_AVATARCLICK:
      return { ...state, avatarClick: action.payload };

    case CURRENT_GROUPID:
      return { ...state, groupId: action.payload };

    case CURRENT_GROUPNAME:
      return { ...state, groupName: action.payload };

    case CHANGE_LEVEL:
      return { ...state, level: action.payload };

    case IS_GROUP_BUTTON:
      return { ...state, isGroupButton: action.payload };

    case CHANGE_INTEGRATION_CHANNEL:
      return { ...state, integration_channel: action.payload };

    case CHAT_STARTED:
      return { ...state, chat_started: action.payload };

    case CHANGE_BACK_TO_LIST:
      return { ...state, backToList: action.payload };

    case CHANGE_CURRENCY:
      return { ...state, currency: action.payload };
      
    case CHANGE_MODE:
      return { ...state, isMessengerMode: action.payload };
  
    default:
      return { ...state };
  }
};
